'use strict';

function isFragment(node) {
    if (typeof node !== 'object' || node === null) return false;
    const keys = Object.keys(node);
    if (!keys.includes(' $fragmentName')) return false;
    if (!keys.includes(' $fragmentRefs')) return false;
    return true;
}

module.exports = isFragment;
